import superagent from 'superagent'
import { debounce } from 'lodash'
import i18n from '../../i18n'
import {
    autoDisplayCollaborativeIndexations,
    initCollaborativeIndexationCampaign,
} from '../collaborativeIndexations/actions'
import {
    backwardMedia,
    initNavigation,
    nextGroup,
    nextMedia,
    previousGroup,
    forwardMedia,
    previousMedia,
} from '../navigation/actions'
import { isListeningKeyboardEventsEnabled } from './selectors'
import { history } from '../../helpers/history'
import { applyStateFromHistory } from '../history/actions'
import { addError } from '../notifications/actions'
import {
    buildQueryString,
    getApiFlattenedQueryParams,
} from '../queryParams/selectors'
import { initGroup } from '../group/actions'
import { initBookmarks } from '../bookmarks/actions'
import { initQueryParams } from '../queryParams/actions'
import { configuration } from '../../configuration'
import { getServerUrl } from '../configuration/selectors'
import { loadConfiguration } from '../configuration/actions'
import { initTableOfContents } from '../tableOfContents/actions'
import { initializeSelector } from '../navigation/selectors'
import { initApp } from '../app/actions'
import { initCurrentMedia } from '../currentMedia/actions'
import { initFetchingMedia } from '../fetchingMedia/actions'
import { initMediaList } from '../mediaList/actions'
import { autoDisplayAside } from "../aside/actions";

export const initialize = (request) => async (dispatch, getState) => {
    dispatch(initializeEvents())
    dispatch(loadConfiguration(configuration))
    dispatch(initQueryParams(request))
    await dispatch(initializeContext())
    dispatch(autoDisplayCollaborativeIndexations())
    dispatch(autoDisplayAside())
}

export const KEYBOARD_PAGEUP = 33
export const KEYBOARD_PAGEDOWN = 34
export const KEYBOARD_UP = 38
export const KEYBOARD_DOWN = 40
export const KEYBOARD_LEFT = 37
export const KEYBOARD_RIGHT = 39

export const UPDATE_VISUALIZER_SIZE = 'UPDATE_VISUALIZER_SIZE'
export const updateVisualizerSize = (width, height) => ({ type: UPDATE_VISUALIZER_SIZE, width, height })

export function initializeEvents()
{
    return async function initializeEvents(dispatch) {
        handleHistoryBrowsing(dispatch)
        handleWindowResize(dispatch)
    }
}

function handleHistoryBrowsing(dispatch)
{
    history.listen((location, action) => {

        if(action !== 'POP') return
        if(location.state === undefined) return

        dispatch(applyStateFromHistory(location.state))
    })
}

function handleWindowResize(dispatch)
{
    dispatch(updateVisualizerSize(window.innerWidth, window.innerHeight))
    window.onresize = debounce(() => {
        dispatch(updateVisualizerSize(window.innerWidth, window.innerHeight))
    }, 500)
}

export function initializeContext(mediaId) {
    return async function initializeContext(dispatch, getState) {

        let flattenedQueryParams = getApiFlattenedQueryParams(getState())
        if(mediaId !== undefined)
        {
            flattenedQueryParams = {
                ...flattenedQueryParams,
                uuid: mediaId,
            }
        }

        const queryParams = buildQueryString(flattenedQueryParams)
        const serverUrl = getServerUrl(getState())
        const url = `${serverUrl}/visualizer/api${queryParams}`

        await superagent.get(url)
            .then((res) => {
                if(res.ok)
                {
                    dispatch(initApp(res.body.app))
                    dispatch(initializeGroup(res.body))
                    dispatch(initBookmarks(res.body.bookmarks))
                    dispatch(initTableOfContents(res.body.tableOfContents))
                    dispatch(initCollaborativeIndexationCampaign(res.body.indexationCampaign))

                    if(res.body.app.locale !== undefined)
                    {
                        i18n.changeLanguage(res.body.app.locale)
                    }
                }
            })
            .catch(() => dispatch(addError('visualizer:error.label')))
    }
}

export function initializeGroup(data) {
    return function initializeGroup(dispatch, getState) {
        const navigation = initializeSelector(data)

        dispatch(initNavigation(navigation))
        dispatch(initFetchingMedia())
        dispatch(initGroup(data.group))
        dispatch(initMediaList(data.media))
        dispatch(initCurrentMedia(data.media[navigation.media.index]))
    }
}

export function listenKeyboardEvents(event) {
    return function listenKeyboardEvents(dispatch, getState) {
        if(! isListeningKeyboardEventsEnabled(getState()))
        {
            return
        }

        switch (event.keyCode) {
            case KEYBOARD_PAGEUP:
                dispatch(backwardMedia())
                break
            case KEYBOARD_PAGEDOWN:
                dispatch(forwardMedia())
                break
            case KEYBOARD_DOWN:
                dispatch(nextGroup())
                break
            case KEYBOARD_UP:
                dispatch(previousGroup())
                break
            case KEYBOARD_LEFT:
                dispatch(previousMedia())
                break
            case KEYBOARD_RIGHT:
                dispatch(nextMedia())
                break
            default:
        }
    }
}

export const ENABLE_LISTENING_KEYBOARD_EVENTS = 'ENABLE_LISTENING_KEYBOARD_EVENTS'
export const enableListeningKeyboardEvents = () => ({ type: ENABLE_LISTENING_KEYBOARD_EVENTS })

export const DISABLE_LISTENING_KEYBOARD_EVENTS = 'DISABLE_LISTENING_KEYBOARD_EVENTS'
export const disableListeningKeyboardEvents = () => ({ type: DISABLE_LISTENING_KEYBOARD_EVENTS })
